import { Icon } from 'leaflet';
import { Marker, Popup } from 'react-leaflet';
import busIcon from '../icons/bus-stop.png';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useAuthorizationContext } from '../context/AuthorizationContext';

const BusStopsComponent = ({ routeId, alignment, busStopIdDest }) => {
  const { headers, getAuthToken } = useAuthorizationContext();
  const [stops, setStops] = useState([]);

  const iconSize = 23;
  const busStopIcon = new Icon({
    iconUrl: busIcon,
    iconSize: [iconSize, iconSize],
  });

  function sortDataBySequence(data, sequenceOrder) {
    const newData = [...data];

    // Sort the newData array based on the sequenceOrder
    newData.sort((a, b) => {
      const sequenceA = sequenceOrder.find((item) => item.code === a.code)?.sequence || 0;
      const sequenceB = sequenceOrder.find((item) => item.code === b.code)?.sequence || 0;
      return sequenceA - sequenceB;
    });

    return newData;
  }

  const getStops = async () => {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/stops/route/${routeId}`, { headers });
      // console.log(data);
      return data;
    } catch (error) {
      console.log(error);
      // handle authorization error
      if (error.request.status === 401) {
        getAuthToken();
      }

      return [];
    }
  };

  const getRouteStopSequence = async () => {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/stops/sequence/route/${routeId}`, { headers });
      // console.log(data);
      return data;
    } catch (error) {
      console.log(error);

      // handle authorization error
      if (error.request.status === 401) {
        getAuthToken();
      }
      return [];
    }
  };

  const getStopsOrdered = async () => {
    let sortedArray;
    const cachedStops = sessionStorage.getItem(`busStops_${routeId}`);
    if (cachedStops) {
      sortedArray = JSON.parse(cachedStops);
    } else {
      const busStopSequence = await getRouteStopSequence();
      const stops = await getStops();
      sortedArray = sortDataBySequence(stops, busStopSequence);
      // cache the route points
      sessionStorage.setItem(`busStops_${routeId}`, JSON.stringify(sortedArray));
    }

    const index = sortedArray.findIndex((stop) => stop.code === busStopIdDest);
    const subArray = alignment === 'to' ? sortedArray.slice(0, index + 1) : sortedArray.slice(index, sortedArray.length);

    setStops(subArray);
  };

  useEffect(() => {
    getStopsOrdered();
  }, [routeId, alignment]);

  return (
    <div>
      {stops.map((stop, index) => (
        <Marker position={[stop.latitude, stop.longitude]} icon={busStopIcon} key={index}>
          <Popup>
            <div className='bus-stop-popup'>{stop.name}</div>
          </Popup>
        </Marker>
      ))}
    </div>
  );
};

export default BusStopsComponent;
